import { AxiosInstance } from 'axios'

interface RevokeCrossSellRequest {
    uid: string
}

interface RevokeCrossSellResponse {
    accepted: boolean
}

export default (api: AxiosInstance) => ({
    async revokeCrossSell(payload: RevokeCrossSellRequest) {
        const result = await api.post<RevokeCrossSellResponse>(
            '/customer/pdpa-revoke-cross-sell',
            payload
        )
        return result.data
    },
})
